import { type ReactNode } from 'react';
import {
  formatVacationRange,
  getVacationDates,
  isOnVacation,
} from '@/utils/vacation';
import type { EnrichedMember } from '../types';

const CHIP =
  'ml-xs inline-flex items-center rounded-sm px-1.5 py-0.5 text-[10px] font-medium';

export function VacationBadge({ a }: { a: EnrichedMember }): ReactNode {
  if (!isOnVacation(a)) return null;
  const { from, to } = getVacationDates(a);
  return (
    <span className={`${CHIP} bg-info/10 text-info`}>
      Vacaciones {formatVacationRange(from, to)}
    </span>
  );
}

export function RedemptionChips({ a }: { a: EnrichedMember }): ReactNode {
  if (a.account_status === 'redemption_test') {
    return (
      <span className={`${CHIP} bg-brand-red/10 text-brand-red`}>
        En redención
      </span>
    );
  }
  if (
    a.account_status === 'banned' &&
    !a.has_used_redemption &&
    !!a.test_passed_at
  ) {
    return (
      <span className={`${CHIP} bg-warning/10 text-warning`}>
        Redención disponible
      </span>
    );
  }
  return null;
}
